export default __webpack_public_path__ + "static/media/menu_icon.da82caef.svg";